var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeRepost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#BDD5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.041 28.573a7.204 7.204 0 0 1 0-14.409h12.12l7.093-2.891a2.483 2.483 0 0 1 3.373 2.318v15.555a2.483 2.483 0 0 1-3.373 2.318l-7.094-2.891h-4.095L26.37 33.2a.663.663 0 0 1-.592.957h-4.086a.662.662 0 0 1-.593-.367l-2.6-5.217H16.04z",
    fill: "#1175D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRepost);
export default __webpack_public_path__ + "static/media/homeRepost.3987c300f4e8199772ae89a5d8a3c7d7.svg";
export { ForwardRef as ReactComponent };